<template>
  <div>
    <app-header title="Film Code Generator" />
    <b-container class="mt-5">
      <b-row>
        <b-col md="6">
          <b-form name="filmForm">
            <b-form-group>
              <label>Category</label>
              <b-form-select
                v-if="filmtypecategories"
                :value="selectedCategory"
                @input="getCategoryFilmtypes"
                required
                :options="filmtypecategories"
                text-field="name"
                value-field="id"
              />
            </b-form-group>
            <b-form-group>
              <label>Film Type</label>
              <b-form-select
                v-model="order.filmtype_id"
                :disabled="!filmtypes"
                required
              >
                <b-form-select-option
                  v-for="filmtype in filmtypes"
                  :key="filmtype.id"
                  :value="filmtype.id"
                >
                  {{ filmtype.name }} ({{ filmtype.description }})
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group>
              <label>Number of Codes</label>
              <b-form-input
                :disabled="!order.filmtype_id"
                v-model="order.count"
                type="number"
                class="form-control"
                placeholder="e.g. 10"
                required
              ></b-form-input>
            </b-form-group>
          </b-form>
          <div class="">
            <b-button
              type="button"
              variant="primary"
              @click="generate()"
              :disabled="!order.count"
            >
              Generate
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>
          <h3>Recent Activity</h3>
          <b-button
            variant="outline-primary"
            size="sm"
            @click="downloadHistory()"
          >
            Download
          </b-button>
          <b-table-simple striped class="mt-3">
            <b-thead>
              <b-tr>
                <b-th>Date</b-th>
                <b-th>User</b-th>
                <b-th>Filmtype</b-th>
                <b-th>Quantity</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="item in history" :key="item.id">
                <b-td>{{ item.created | moment('YYYY-MM-DD') }}</b-td>
                <b-td>{{ item.useremail }}</b-td>
                <b-td
                  >{{ item.filmtype_name }} ({{
                    item.filmtype_description
                  }})</b-td
                >
                <b-td>{{ item.quantity }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $csv from '@/services/csv';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
  },

  data() {
    return {
      order: {},
      filmtypes: null,
      history: null,
      selectedCategory: null,
      filmtypecategories: null,
    };
  },

  created() {
    this.refreshData();
    this.refreshHistory();
  },

  methods: {
    async refreshHistory() {
      this.history = await $api.get('/v1/internal/filmcodehistory');
    },

    async refreshData() {
      this.filmtypecategories = await $api.get('/v1/common/filmtypecategories');
    },

    async getCategoryFilmtypes(categoryId) {
      this.filmtypes = null;
      const { filmtypes } = await $api.get(
        `/v1/internal/filmtypecategories/${categoryId}`,
      );
      this.filmtypes = filmtypes;
    },

    async generate() {
      const filmType = this.filmtypes.filter(
        (ft) => ft.id === this.order.filmtype_id,
      )[0];
      const filmTypeName = `${filmType.name} (${filmType.description})`;
      const codes = await $api.post('/v1/internal/filmcodes', this.order);
      const rows = codes.map((code) => ({ code, type: filmTypeName }));
      $csv.export(
        rows,
        ['code', 'type'],
        `${this.order.count}x${filmTypeName} codes.csv`,
      );
      this.refreshHistory();
    },

    downloadHistory() {
      $csv.export(
        this.history,
        [
          'created',
          'useremail',
          'filmtype_name',
          'filmtype_description',
          'useremail',
        ],
        'filmcodehistory.csv',
      );
    },
  },
};
</script>
